<template>
  <div class="zero-buy-box">
    <div class="container">
      <img src="@/assets/images/mall/zero-buy-back.png" class="back" alt="" />
      <img src="@/assets/images/mall/zero-buy-receive.png" class="receive" @click.stop="goDetail" alt="" />
    </div>
    <img src="@/assets/images/mall/zero-buy-close.png" class="close" @click.stop="close" alt="" />
  </div>
</template>

<script>
export default {
  name: 'zeroBuyBox',
  data() {
    return {}
  },
  props: ['id', 'activityId'],
  watch: {},
  mounted() {},
  methods: {
    close() {
      this.$emit('close')
    },
    goDetail() {
      this.id && this.activityId
        ? this.$router.push({
            name: 'zeroSaleCar',
            params: { id: this.id, activityId: this.activityId }
          })
        : this.$feedback('活动车辆不存在')
    }
  },
  created() {}
}
</script>
<style lang="scss" scoped>
.zero-buy-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  img {
    display: block;
  }
  .container {
    margin: 262px auto 47px;
    position: relative;
    width: 474px;
    height: 407px;
    .back {
      width: 474px;
      height: 407px;
    }
    .receive {
      position: absolute;
      top: 297px;
      left: 59px;
      width: 360px;
      height: 98px;
    }
  }
  .close {
    width: 54px;
    height: 54px;
    margin: 0 auto;
  }
}
</style>
